import { render, staticRenderFns } from "./baby-paradise.vue?vue&type=template&id=5d4208db&scoped=true&"
import script from "./baby-paradise.vue?vue&type=script&lang=js&"
export * from "./baby-paradise.vue?vue&type=script&lang=js&"
import style0 from "./baby-paradise.vue?vue&type=style&index=0&id=5d4208db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4208db",
  null
  
)

export default component.exports